<template>
    <div :class="[buttonClass, button ? value ? 'bg-secondary-5 font-semibold border-secondary' : 'bg-white hover:bg-primary-5 border-primary-20': '']"
    >
        <label class="flex items-center cursor-pointer group">
            <input :checked="value" class="hidden border-none" type="checkbox" @change="toggle">
            <svg-icon :class="[value ? iconActiveColor: iconColor, iconSize, 'group-hover:'+ iconHoverColor]" :type="icon"></svg-icon>

            <span v-if="$slots.default" class="pl-8">
                <slot></slot>
            </span>
        </label>
    </div>
</template>

<script>
import SvgIcon from '../ui/SvgIcon';

export default {
    components: {SvgIcon},
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: Boolean,
        button: { //Create button like (UX)
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            required: true,
        },
        iconSize: {
            type: String,
            default: 'w-16 h-16',
        },
        iconColor: {
            type: String,
            default: 'text-primary-80',
        },
        iconHoverColor: {
            type: String,
            default: 'text-primary',
        },
        iconActiveColor: {
            type: String,
            default: 'text-secondary',
        },
    },
    computed: {
        buttonClass() {
            return this.button ? 'mb-8 py-8 px-14 mr-12 rounded-4 bg-white border border-primary-20 hover:bg-primary-5 inline-flex items-center cursor-pointer' : '';
        },
    },
    methods: {
        toggle: function (event) {
            this.$emit('change', !this.value && event.target.value === 'on');
        },
    },
};
</script>